import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import find from 'lodash/find';
import Information from 'modules/Information';
import { renderLegalConsentField } from '../renderers';
const MissingConsents = ()=>{
    const consentsTemplate = useSelector(Information.selectors.consentsTemplate);
    const information = useSelector(Information.selectors.information);
    const missingConsents = consentsTemplate.filter((consent)=>{
        if (!consent.isMandatory) return false;
        const { legalConsentId } = consent;
        const approval = find(information.legalConsentApprovals, {
            legalConsentId
        });
        return !approval || !approval.decision;
    });
    if (!missingConsents.length) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: missingConsents.map(renderLegalConsentField)
    });
};
export default MissingConsents;
